export default function RadioGroup(props) {
    const {
        value,
        onChange,
        options,
        groupName,
        small,
        horizontal,
        className,
        ...rest
    } = props;

    return (
        <div {...rest} className={`${horizontal ? "flex gap-2" : "space-y-2"} ${className}`}>
            {options.map((option, index) => (
                <label key={index} htmlFor={`${groupName}${option.value}`} onClick={() => onChange(option.value)}  className="flex gap-1 items-center text-sm font-normal">
                    {option.label}
                    <div className={`${small ? "h-4 w-4" : "h-5 w-5"} rounded-full mr-2 flex items-center justify-center ${option.value === value ? "bg-light-3" : "border border-light-2"}`}>
                        <div className={`bg-white ${small ? "h-2 w-2" : "h-2.5 w-2.5"} rounded-full`} />
                    </div>                        
                    <input
                        id={`${groupName}${option.value}`}
                        type="radio"
                        name={groupName}
                        value={option.value}
                        checked={option.value === value}
                        onChange={onChange}
                        className="hidden"
                    />
                </label>
            ))}
        </div>
    );
}

/*

Sample Props

value={value}
small={true}
horizontal={true}
onChange={value => setValue(value)}
groupName="whatever" //option group name
className="classes"
options={[
    {label: "Option 1", value: "1"},
    {label: "Option 2", value: "2"},
    {label: "Option 3", value: "3"},
]}

 */
